import React from 'react';
import './css/CorporateResponsibility.css';
// import pictureOne from './assets/DG-SO MANDALADSC_1.jpg';
import pictureOne from './assets/DIRECTOR GENERAL.jpeg';
import pictureTwo from './assets/Senganimalunje-scaled.jpg';
import pictureThree from './assets/1714194267143.jpg';
import pictureFour from './assets/Mrs Gloria Chaonamwene Mereke.jpg';
import pictureFive from './assets/MrKuyeli.jpg';
import pictureSix from './assets/Moyo.jpg';
import pictureSeven from './assets/CA. Bright McLean Dzoolie.jpg';
import pictureEight from './assets/Dr. Stephen Chalimba.jpg';
import headerBg from './assets/picOne.png';
import { motion } from 'framer-motion';
           
const profiles = [
  { name: 'Mr. Symon O. Mandala', title: 'Director General', img: pictureOne },
  { name: 'Mr. Thomas Senganimalunje', title: 'Deputy Director General', img: pictureTwo },
  { name: 'Mr. Fred Sikwese', title: 'Director of Standards Development', img: pictureThree },
  { name: 'Mrs Gloria Chaonamwene Mereka', title: 'Director of Quality Assurance Services', img: pictureFour },
  { name: 'Mr. Stephen Kuyeli', title: 'Director of Testing Services', img: pictureFive },
  { name: 'Mr. Rex Moyo', title: 'Director of Human Resources & Administration', img: pictureSix },
  { name: 'CA. Bright McLean Dzoole', title: 'Director of Finance', img: pictureSeven },
  { name: 'Dr. Stephen Chalimba', title: 'Director of Metrology Services', img: pictureEight },
];
                                      
const Responsibility = () => {
  const directorGeneral = profiles[0];    
  const deputyDirector = profiles[1];
  const directors = profiles.slice(2);
    
  return (
    <div className="header-responsibility">
      {/* === Overlay Header === './assets/DG-mbs.jpg'; */}
      <section 
        className="responsibility-header" 
        style={{
          backgroundImage: `url(${headerBg})`, 
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '40vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      > 

        <div className="overlay">
          <h1 className="page-title">MBS Management</h1>
          <p className="subtitle">
            Meet the leadership team of the Malawi Bureau of Standards (MBS). Our management provides strategic direction and ensures we uphold the highest standards of quality, safety, and integrity.
          </p>
        </div>
      </section>

      {/* === ORGANOGRAM SECTION === */}
      <section className="organogram" style={{ maxWidth: '1200px', margin: '40px auto' }}>
        {/* === Director General === */}
<div className="org-level top">
  <motion.div
    className="profile-card"    
    whileHover={{ scale: 1.05 }}
    transition={{ type: 'spring', stiffness: 200 }}
    style={{
      width: '360px',          // ⬅️ wider white card
      maxWidth: '100%',
    }}
  >


    <img
      src={directorGeneral.img}
      alt={directorGeneral.name}
      className="profile-image"
      style={{
        width: '100%',          // ⬅️ image spans card width
        height: '300px',        // ⬅️ taller but clean 
        objectFit: 'cover',
      }}
    /> 


     
    <div className="profile-caption">
      <strong>{directorGeneral.name}</strong><br />
      <span
  className="orange-bold"
  style={{
    fontSize: '1.25rem',   // ⬅️ bigger text
    fontWeight: 800,
    display: 'inline-block',
    marginTop: '4px',
  }}
>
  {directorGeneral.title}
</span>
    </div>
  </motion.div>
</div>
        {/* === Director General ===
        <div className="org-level top">
          <motion.div
            className="profile-card"
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 200 }}
          >
            <img src={directorGeneral.img} alt={directorGeneral.name} className="profile-image" />
            <div className="profile-caption">
              <strong>{directorGeneral.name}</strong><br />
              <span className="orange-bold">{directorGeneral.title}</span> 
            </div>
          </motion.div>
        </div>  */}
 

        {/* === DG BIO (WIDE DESCRIPTION) === */}
        {/* <div className="bio-box"> */}
          {/* <h3 className="orange-bold"></h3> */}    
          {/* <p>
            Prof. Bernard Thole is an Associate Professor in Applied Industrial Chemistry, an accomplished Consultant and Researcher. From 1996 to 1998, he served as a Standards Officer for Chemicals and Textiles before being promoted to Standards Manager for the same division, a role he held from 1998 to 2001. He later joined the University of Malawi (UNIMA), now Malawi University of Business and Applied Sciences (MUBAS), where he gained extensive leadership experience. He served two terms as Dean of the Faculty of Applied Sciences, from 2007–2009 and 2016–2018. He rejoined the Malawi Bureau of Standards as Director General in March 2023.
          </p> */}
        {/* </div> */}

        <div className="connector-vertical"></div>         

        {/* === Deputy DG === */}          
        <div className="org-level mid">
          <motion.div
            className="profile-card"
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 200 }}   
          >
            <img src={deputyDirector.img} alt={deputyDirector.name} className="profile-image" />
            <div className="profile-caption">
              <strong>{deputyDirector.name}</strong><br />
              <span className="orange-bold">{deputyDirector.title}</span>
            </div>
          </motion.div>
        </div>

        <div className="connector-vertical"></div>

        {/* === Directors Grid === */}
        <div className="org-level bottom">
          {directors.map((profile, index) => (
            <motion.div
              key={index}
              className="profile-card small"
              whileHover={{ scale: 1.05 }}
              transition={{ type: 'spring', stiffness: 200 }}
            >
              <img src={profile.img} alt={profile.name} className="profile-image" />
              <div className="profile-caption">
                <strong>{profile.name}</strong><br />
                <span className="orange-bold">{profile.title}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* === Inline Styles === */}
      <style>{`
      .responsibility-header .overlay {
    background: rgba(0, 0, 0, 0.5);
    padding: 2rem;
    border-radius: 1rem;
    border-right: 4px solid #ff6600;
    border-left: 4px solid #ff6600;
    width: 90%;
}
          .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
        .orange-bold {
          color: #ff6600;
          font-weight: 700;
        }
        .bio-box {
  width: 100%;
  margin: -20px auto 30px auto; /* top -30px, left/right auto, bottom 30px */
  background: white;
  padding: 22px;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
  line-height: 1.6;
}

        .bio-box h3 {
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};

export default Responsibility;
